<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      大区中心
    </div>

    <el-table
      :data="tableData"
      style="width:100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="大区编号" prop="opId"> </el-table-column>

      <el-table-column label="负责人" prop="contactsName"> </el-table-column>

      <el-table-column label="手机号" prop="contactsPhone"> </el-table-column>

      <el-table-column label="微信号" prop="contactsWxno"> </el-table-column>

      <el-table-column label="地址" prop="address"> </el-table-column>

      <el-table-column label="创建时间" prop="addtime"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      tableData: [],
      shanghai: "",
      beijing: "",
      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  created() {
    // this.getOperateInfo();
  },

  methods: {
    // getOperateInfo() {
    //   this.$api.activitymsg.getOperateInfo({}).then((e) => {
    //     this.tableData = e.data;
    //   });
    // },
  },
};
</script>

<style scoped></style>
